/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { PackagesGuard } from '@core/guards/packages.guard';
import { Flow, RoutePaths } from '@global/routePaths';
import { CancelPolicyRoutes } from './cancel-policy/cancel-policy.routing';
import { DiscontinuePolicyRoutes } from './discontinue-policy/discontinue-policy.routing';
import { EmailRoutes } from './email/email.routing';
import { ModifyPolicyActionsRoutes } from './modify-policy-actions/modify-policy-actions.routing';
import { PolicyActionsRoutes } from './policy-actions/policy-actions.routing';

export const ModifyPolicyRoutes: Routes = [
  ...EmailRoutes,
  ...PolicyActionsRoutes,
  ...ModifyPolicyActionsRoutes,
  ...CancelPolicyRoutes,
  ...DiscontinuePolicyRoutes,
  {
    path: RoutePaths.MODIFY_POLICY.CONFIRM_DATA.SUMMARY.route,
    loadChildren: () =>
      import('@pages/confirm-data/project-summary/project-summary.module').then(m => m.ProjectSummaryPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.POLICY_SUMMARY.route,
    loadChildren: () =>
      import('@pages/modify-policy-summary/modify-policy-summary.module').then(m => m.ModifyPolicySummaryPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.HOME_DATA.HOME_TYPE.route,
    loadChildren: () => import('@pages/home-data/home-type/home-type.module').then(m => m.HomeTypePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.HOME_DATA.FLOOR_NUMBER.route,
    loadChildren: () => import('@pages/home-data/floor-number/floor-number.module').then(m => m.FloorNumberPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.HOME_DATA.HOME_SIZE.route,
    loadChildren: () => import('@pages/home-data/home-size/home-size.module').then(m => m.HomeSizePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.HOME_DATA.ALARM_TYPE.route,
    loadChildren: () => import('@pages/home-data/alarm-type/alarm-type.module').then(m => m.AlarmTypePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.POLICY_DATA.COVERAGES.route,
    loadChildren: () => import('@pages/policy-data/coverages/coverages.module').then(m => m.CoveragesPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.POLICY_DATA.PACKAGES.route,
    loadChildren: () => import('@pages/policy-data/packages/packages.module').then(m => m.PackagesPageModule),
    canActivate: [NavigationGuard, PackagesGuard],
    data: { parentPath: RoutePaths.MODIFY_POLICY.POLICY_DATA, flow: Flow.MODIFY_POLICY },
  },
  {
    path: RoutePaths.MODIFY_POLICY.POLICY_HOLDER.HOME_ADDRESS.route,
    loadChildren: () =>
      import('@pages/policy-holder-data/home-address/home-address.module').then(m => m.HomeAddressPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.POLICY_HOLDER.POLICY_HOLDER_RESIDENCE.route,
    loadChildren: () =>
      import('@pages/policy-holder-data/policy-holder-residence/policy-holder-residence.module').then(
        m => m.PolicyHolderResidencePageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.ADDITIONAL_DATA.MORTGAGE_FORM.route,
    loadChildren: () =>
      import('@pages/additional-data/mortgage-form/mortgage-form.module').then(m => m.MortgageFormPageModule),
    canActivate: [NavigationGuard],
  },
];
